import { useState } from 'react';

import DeleteOutline from '@mui/icons-material/DeleteOutlined';
import { Box, Typography } from '@/shared/ui';

import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import type { TabSymbol } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { SymbolAlias } from '@/features/dashboard/components/SymbolAlias';
import { Dialog, DialogButton } from '@/shared/ui/overlays/Modal';
import presets from '@/shared/ui/overlays/Modal/presets';
import { NameInput } from '@/shared/ui/primitives/NameInput';
import TypographyComponent from '@/shared/ui/typography/Text';

const rootSx = { display: 'flex', alignItems: 'center' };
const contentSx = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  pr: 1
};
const deleteBtnSx = {
  display: 'flex',
  width: '32px',
  height: '32px',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'gx.textDisabled',
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  opacity: 1,
  ml: 'auto'
};
const deleteIconSx = { fontSize: 16, color: 'gx.text' };

export const SymbolContent = ({ symbol, index }: { symbol: TabSymbol; index: number }) => {
  const { updateSymbol, removeSymbol, form, setCanPreview } = useAppForm();
  const type = form.state.values?.type;

  const [isDelete, setIsDelete] = useState(false);

  return (
    <Box sx={rootSx}>
      <Box sx={contentSx}>
        <TypographyComponent size={14}>#{index + 1}</TypographyComponent>
        <TypographyComponent
          size={14}
          sx={{ width: 100, ml: 3 }}
        >
          <SymbolAlias
            symbol={symbol}
            type={type}
          />
        </TypographyComponent>

        <NameInput
          value={symbol.shortTitle}
          onBlur={() => {
            setCanPreview(true);
          }}
          onChange={val => {
            updateSymbol({
              ...symbol,
              shortTitle: val
            });
          }}
          onFocus={() => {
            setCanPreview(false);
          }}
        />
      </Box>
      <Box
        component='button'
        sx={deleteBtnSx}
        onClick={() => {
          setIsDelete(true);
        }}
      >
        <DeleteOutline sx={deleteIconSx} />
      </Box>
      <Dialog
        buttons={
          <>
            <DialogButton
              variant='outlined'
              onClick={() => {
                setIsDelete(false);
              }}
            >
              {presets.removeItem.cancelText}
            </DialogButton>
            <DialogButton
              variant='contained'
              onClick={() => {
                removeSymbol(symbol);
                setIsDelete(false);
              }}
            >
              {presets.removeItem.confirmText}
            </DialogButton>
          </>
        }
        open={isDelete}
        title={presets.removeItem.title}
        onClose={() => {
          setIsDelete(false);
        }}
      >
        <Typography>{presets.removeItem.text}</Typography>
      </Dialog>
    </Box>
  );
};
